var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-content infos" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-inner-content" },
      [
        _c("InputWrapper", {
          attrs: { placeholder: "Name", "max-chars": 15 },
          model: {
            value: _vm.Global.mockupConfig.infos.name,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.infos, "name", $$v)
            },
            expression: "Global.mockupConfig.infos.name",
          },
        }),
        _vm._v(" "),
        _c("InputWrapper", {
          attrs: { placeholder: "Company", "max-chars": 15 },
          model: {
            value: _vm.Global.mockupConfig.infos.company,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.infos, "company", $$v)
            },
            expression: "Global.mockupConfig.infos.company",
          },
        }),
        _vm._v(" "),
        _c("InputWrapper", {
          attrs: { placeholder: "Email" },
          model: {
            value: _vm.Global.mockupConfig.infos.email,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.infos, "email", $$v)
            },
            expression: "Global.mockupConfig.infos.email",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nxt-out" },
          [
            _c("div", { staticClass: "bgout" }),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn main txt-blk",
                attrs: { tag: "div", to: "/content" },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro-block" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Your informations")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "To be sure we will send you the right information in the right place, please provide your data."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }